<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex burger-spacing justify-content-between">
        <back-arrow :title="$t('Modify') + ' ' + $t('l.i') + ' ' + $t('user')"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form @submit.stop.prevent="onSubmit">

              <div class="row">

                <!-- nom -->
                <div class="col-md-6">
                  <string-field
                    :label="$t('user.Lastname') + ' *'"
                    :id="'lastname-input'"
                    :input-value="this.form.lastname"
                    v-model="this.form.lastname"
                    :is-required="true">
                  </string-field>
                </div>

                <!-- prénom -->
                <div class="col-md-6">
                  <string-field
                    :label="$t('user.Firstname') + ' *'"
                    :id="'firstname-input'"
                    :input-value="this.form.firstname"
                    v-model="this.form.firstname"
                    :is-required="true">
                  </string-field>
                </div>

                <!-- email -->
                <div class="col-md-6">
                  <string-field
                    :label="$t('user.Username') + ' *'"
                    :id="'username-input'"
                    :input-value="this.form.username"
                    v-model="this.form.username"
                    :type="'email'"
                    :is-required="true">
                  </string-field>
                </div>

                <!-- téléphone -->
                <div class="col-md-6">
                  <phone-number-field
                    :phone-number="this.form.phoneNumber"
                    v-model="this.form.phoneNumber">
                  </phone-number-field>
                </div>

                <!-- role -->
                <div class="col-md-6" v-if="user && user.role !== 'ROLE_SUPER_ADMIN'">
                  <select-field
                    :label="$t('Role') + ' *'"
                    :id="'role-input'"
                    :select-value="this.form.role"
                    v-model="this.form.role"
                    :options="roles"
                    :is-enum="true"
                    :is-required="true">
                  </select-field>
                </div>

                <!-- commissions -->
                <div class="col-md-6" v-if="form.role.value === 'ROLE_COMMISSION'">
                  <select-field
                    :label="$t('Commission')"
                    :id="'commissionId'"
                    :select-value="this.form.commissionId"
                    v-model="this.form.commissionId"
                    :options="commissions"
                    :is-required="true">
                  </select-field>
                </div>

              </div>

              <div class="d-flex justify-content-end">
                <b-button type="submit" variant="secondary">
                  <span v-if="!isLoading">{{ $t('Validate') }}</span>
                  <b-spinner v-else :label="$t('spinner.isLoading')" small></b-spinner>
                </b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import i18n from '../../i18n'
import PhoneNumberField from "../../components/b122/editFields/PhoneNumberField.vue"
import StringField from "../../components/b122/editFields/StringField.vue";
import SelectField from "../../components/b122/editFields/SelectField.vue";

export default {

  name: 'UserEdit',

  components: {
    SelectField,
    StringField,
    PhoneNumberField,
    BackArrow
  },

  data () {
    return {

      userId: this.$route.params.userId,
      user: null,
      roles: [],
      commissions: [],
      isLoading: false,
      form: {
        firstname:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lastname:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        username:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        phoneNumber:
          {
            state: null,
            invalidFeedback: null,
            value: null,
            formattedNumber: null,
            countryCode: null
          },
        role:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        commissionId:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      }
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {

    async fetchData () {
      await this.fetchRoles()
      await this.fetchCommissions()
      this.fetchUser()
    },

    async fetchRoles () {
      await api
        .get(`/role/getRoles`)
        .then(response => {
          this.roles = response.data
        })
    },

    async fetchCommissions () {
      await api
        .get(`/commission`)
        .then(response => {
          this.commissions = response.data
        })
    },

    fetchUser () {
      api
        .get(`/user/${this.userId}`)
        .then(response => {
          this.user = response.data
          this.setInitialValues()
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'UserIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    setInitialValues () {
      this.form.firstname.value = this.user.firstname
      this.form.lastname.value = this.user.lastname
      this.form.username.value = this.user.username
      this.form.phoneNumber.value = this.user.phoneNumber
      this.form.phoneNumber.countryCode = this.user.phoneCountryCode
      this.form.role.value = this.user.role
      this.form.commissionId.value = this.user.commission? this.user.commission.id : null
    },

    onSubmit () {

      this.isLoading = true

      let data = new FormData()
      data.append('firstname', this.form.firstname.value)
      data.append('lastname', this.form.lastname.value)
      data.append('username', this.form.username.value)
      data.append('phoneNumber', this.form.phoneNumber.formattedNumber)
      data.append('phoneCountryCode', this.form.phoneNumber.countryCode)
      data.append('role', this.form.role.value)
      if (this.form.commissionId.value) {
        data.append('commissionId', this.form.commissionId.value)
      }

      api({
        method: 'POST',
        url: `/user/${this.user.id}`,
        data: data
      })
        .then(() => {
          this.$router.push({
            name: 'UserShow',
            params: {
              userId: this.user.id
            }
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.form.username.value)
            })
          })
        })
        .catch((error) => {
          this.isLoading = false
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'UserIndex',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = i18n.t(error.response.data.message)
          }
        })
    },

    successToast (userName) {
      this.$bvToast.toast(this.$i18n.t('User') + ' "' + userName + '" ' + this.$i18n.t('modified'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/user/UserEdit.vue